import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Globals } from '../../../../globals';
import { HttpInterceptor } from '../../../../interceptors/http-interceptor.service';
import { PermisoService } from '../../../../providers/permiso.service';
import { EntidadResponsable } from './entidad-responsable';
import { GeneralService } from '../../../../providers/general.service';

@Injectable()
export class EntidadResponsableService {
    constructor(
        private http: HttpInterceptor,
         private globals: Globals,
        private general: GeneralService,
        private permisoService: PermisoService
    ) { }

    getEntidadResponsables(
        paginado: any = {
            page: null,
            pageSize: null
        },
        orden: any = {
            sort: null,
            order: null
        },
        filtros: any = {
            generico: ''
        }): Observable<any> {
        return this.permisoService.getPermisoAction('ENTIDAD-RESPONSABLES-VER')
            .switchMap((controllerAction) => {
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            paginado: paginado,
                            orden: orden,
                            filtros: filtros
                        })
                    )
                    .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                        (respuesta: Response) => respuesta.json()
                    );
            });
    }

    crearResponsableEntidad(
        IdEntidad: number | string,
        responsable: EntidadResponsable
    ): Observable<any> {
        return this.permisoService.getPermisoAction('ENTIDAD-RESPONSABLE-CREAR')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            IdEntidad: IdEntidad,
                            responsable: responsable
                        })
                    );
            })
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                (respuesta: Response) => respuesta.json());
    }

    eliminarResponsableEntidad(IdEntidadResponsable: number | string): Observable<any> {
        return this.permisoService.getPermisoAction('ENTIDAD-RESPONSABLE-ELIMINAR')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            IdUsuResponsable: IdEntidadResponsable
                        })
                    );
            })
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                (respuesta: Response) => respuesta.json());
    }
}